import { setSentryTag } from "./set-sentry-tag.js";

export type SentryTrackingData = {
  partnerId: number | null | undefined;
  locationInfo: {
    countryCode?: string;
    city?: string;
    isp?: string;
    org?: string;
  };
};

export const syncSentryTrackingDataTags = ({ partnerId, locationInfo }: SentryTrackingData): void => {
  setSentryTag("partnerId", partnerId);
  setSentryTag("countryCode", locationInfo.countryCode);
  setSentryTag("city", locationInfo.city);
  setSentryTag("isp", locationInfo.isp);
  setSentryTag("org", locationInfo.org);
};
